angular.module('EdxSchoolReportModule', []);